/**
 * In-page "jump to section" links (e.g. the Size Guide's garment nav).
 *
 * The same page content can be rendered more than once on a single
 * product page — the "Size & Fit Guide" accordion tab and the "Size
 * chart" popup both pull in the Size Guide page — so the ids these links
 * target (#size-short, etc.) are duplicated in the DOM. `getElementById`
 * always returns the first match, which silently scrolls the wrong,
 * possibly-hidden copy. Scope the lookup to the nearest scrollable
 * ancestor of the clicked link instead, so it always resolves to the
 * copy the link actually belongs to — that same ancestor is also exactly
 * what needs to scroll (the popup's own scroll container, the accordion
 * tab's, or the page itself), so it works the same everywhere this
 * content is reused.
 */
(function () {
  function isScrollable(el) {
    var style = window.getComputedStyle(el);
    return /(auto|scroll)/.test(style.overflowY) && el.scrollHeight > el.clientHeight;
  }

  function findScrollableAncestor(el) {
    var node = el.parentElement;
    while (node && node !== document.body) {
      if (isScrollable(node)) return node;
      node = node.parentElement;
    }
    return document.scrollingElement || document.documentElement;
  }

  function handleClick(event) {
    var link = event.target.closest('.content-jumplinks a[href^="#"]');
    if (!link) return;

    var id = link.getAttribute('href').slice(1);
    if (!id) return;

    var container = findScrollableAncestor(link);
    var target = container.querySelector('#' + CSS.escape(id)) || document.getElementById(id);
    if (!target) return;

    event.preventDefault();
    target.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  document.addEventListener('click', handleClick);
})();
